"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  DATA_DELETION_REQUEST,
  CANCELLATION_REFUND,
  SHIPPING_DELIVERY,
} from "routes";

const LINKS = [
  { href: DATA_DELETION_REQUEST, label: "Data Deletion Request" },
  { href: CANCELLATION_REFUND, label: "Cancellation & Refund" },
  { href: SHIPPING_DELIVERY, label: "Shipping & Delivery" },
];

export default function PolicyNav() {
  const pathname = usePathname();

  return (
    <nav className="sticky top-[60px] z-30 flex items-center gap-2 overflow-x-auto bg-white px-4 md:px-16 lg:px-20 border-b border-gray-100">
      {LINKS.map(({ href, label }) => {
        const isActive = pathname === href;
        return (
          <Link
            key={href}
            href={href}
            aria-current={isActive ? "page" : undefined}
            className={`shrink-0 px-3 md:px-5 text-[14px] ${
              isActive
                ? "text-[#282886] font-semibold hover:opacity-90"
                : "text-primarytext hover:text-[#282886] transition-colors"
            }`}
          >
            <span
              className={`inline-block whitespace-nowrap py-2.5 border-b-[3px] ${
                isActive ? "border-[#282886]" : "border-transparent"
              }`}
            >
              {label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
